import { Component, Output, EventEmitter, ElementRef, Input, ViewChild } from '@angular/core';
import { DispatchBoardPanels } from "../../shared/enums/DispatchBoardPanels";
import { WindowContents } from '../../shared/enums/windowContents';
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../shared/services/globals.service';
import { EmployeeService } from '../../shared/services/employee.service';
import { DispatchDropLocation } from '../../shared/models/DispatchDropLocation';
import { of, Subscription } from 'rxjs';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { SchedulerEvent, SchedulerComponent, SchedulerSlot, SlotClassArgs } from '@progress/kendo-angular-scheduler';
import { BaseAppEditComponent } from '../../shared/base-components/base-app-edit.component';
import { DQOIReferenceDataQuery } from '../../dqoi/state/dqoi-reference-data.query';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { v_LocationDetailBus } from '../../shared/models/v_LocationDetailBus';
import { DateFunctions } from '../../shared/static/date-functions';
import { delay, mergeMap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'cp-tech-panel-calendar-all',
    templateUrl: './tech-panel-calendar-all.component.html',
    styleUrls: ['./tech-panel-calendar-all.component.scss']
})

export class TechPanelCalendarAllComponent extends BaseAppEditComponent<null, DispatchBoardService> {

    subscriptions: Subscription[] = [];

    constructor(globals: GlobalsService,   qry_rd: DQOIReferenceDataQuery, private svc_globals: GlobalsService, public svc_data: DispatchBoardService, private svc_data_emp: EmployeeService) {
        super(globals, qry_rd);
        this.subscriptions.push(svc_data.assignTech$.subscribe(
            dispatch => {
                this.openWindow(dispatch);
            }));
        this.subscriptions.push(svc_data.hoverTechPanel$.subscribe(
            tech => {
                if (tech) {

                    this.openDetail(tech);
                }
            }));
        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                this.initData();
            }));
        this.subscriptions.push(svc_data.refreshCalendar$.subscribe(
            refresh => {
                if (refresh) { this.initData(); }
            }));

        //this.subscriptions.push(svc_data.refreshCalendar$.subscribe(
        //    curValue => {
        //        this.showFutureClick(curValue);
        //    }));

    }
    @ViewChild('scheduler', { static: true })
    public scheduler: SchedulerComponent;
    public techList = [];
    public currentYear = new Date().getFullYear();
    public currentDay = new Date().getDate();
    public currentMonth = new Date().getMonth();
    public displayDate = new Date(this.currentYear, this.currentMonth,this.currentDay);
    public parseAdjust = (eventDate: string): Date => {
        const date = new Date(eventDate);
        date.setFullYear(this.currentYear);
        return date;
    };
    public resourceCount: number = 1;  // this one is for you brian
    public selectedDate: Date = new Date(this.currentYear, this.currentMonth, this.currentDay);
    public events: SchedulerEvent[] = [];
    public group: any = {
        resources: ['Techs'],
        orientation: 'horizontal'
    };
    public showFutureClick(event) {
        this.showFuture = event;
        //this.showFuture = event.currentTarget.checked;
        this.svc_data.setShowfutureDispatchs( this.showFuture );
        this.createEvents( this.selectedDate );

    }
    public resources: any[]
        = [{
        name: 'Techs',
        data: [
            { text: '', value: 2, color: '#f58a8a' }
        ],
        field: 'roomId',
        valueField: 'value',
        textField: 'text',
        colorField: 'color'
    }];

    private _mouseEnterStream: EventEmitter<any> = new EventEmitter();
    private _mouseLeaveStream: EventEmitter<any> = new EventEmitter();

    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    data: any = [];
    searchParam: DispatchBoardSearch;
    filterSettings: DropDownFilterSettings;
    workDayStart = "07:00";
    workDayEnd = "16:00";
    slotDuration = 120;
    panelType: DispatchBoardPanels = DispatchBoardPanels.tech;
    boardPersonsData: any;
    @Input() selectedView: string;
    @Input() viewName: any;
    @Input() boardStyle: boolean = false;
    showFuture: boolean = false;
    @Output() viewChange = new EventEmitter<boolean>();
    @Output() openRequest = new EventEmitter<object>();
    @Output() openDetailRequest = new EventEmitter<object>();
    @Output() dispatchDrag = new EventEmitter<object>();
    @Output() moveDispatch = new EventEmitter<object>();
    @Output() assignDispatch = new EventEmitter<object>();
    @Output() unAssignDispatch = new EventEmitter<object>();
    @Output() viewDispatch = new EventEmitter<object>();
    @Output() panelDispatch = new EventEmitter<object>();

    popupLock: boolean = false;
    loadingIndicator: boolean = true;
    quickFilter: string;
    quickFilterError: boolean = false;
    slot : SchedulerSlot;
    mouseDown: boolean = false;

    public contentTypes = WindowContents;
    public scheduleWidth:string = '100%';
    @ViewChild('myIdentifier', { static: true }) myIdentifier: ElementRef;
    public scheduleToolbarWidth: any;
    public popupClass: string = 'cp-light-popup';
    textColor: string;
    public slotClass = args => ({ myClass: true });
    public weekViewWrap: boolean = false;

    ngOnChanges() {
        this.initData();
    }
    ngOnInit() {
        this.searchParam = this.sch;
        this.searchParam.userId = this.svc_globals.userId;
        this.filterSettings = this.svc_data.filterSettings;
        this.svc_data.setStartDate(this.selectedDate);
    }

    checkWidth(){
     //   var width = 500;// this.myIdentifier.nativeElement.offsetWidth;
        var width =  this.myIdentifier.nativeElement.offsetWidth;
        this.scheduleToolbarWidth = {'width': (width - 8) +'px'};
        return this.scheduleToolbarWidth;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    dateChangeEvent($event) {
        this.selectedDate = $event.selectedDate;
        this.svc_data.setStartDate(this.selectedDate);
        this.createEvents($event.selectedDate)
    }
    dragOver($event) {
        //if ($event.buttons == 1)

        //{ this.slot = this.scheduler.slotByPosition($event.pageX, $event.pageY); }
        var a = 1;
    }
    mouseLeave($event) {
        this.slot = null;
    }
    dragEnd($event) {
        var a = 1;
        if (!$event.isAllDay ) {

            if (this.isAvailable($event.start, $event.resources.roomId)) {
                this.svc_data.dispatchDragging($event.dataItem.dataItem.dispatch, true);
                var tech = new DispatchDropLocation();
                tech.tech = $event.resources.roomId;
                tech.dateTime = $event.start;
                tech.dropTarget = 7;
                tech.dispatchId = $event.dataItem.dataItem.dispatch.dispatchId;
                tech.dispatchAssignmentId = $event.dataItem.id;
                this.svc_data.dispatchDropped(tech);
                this.mouseDown = false;
            } else {
                var uName= "User"
                var person = this.techList.find(a => a.value == $event.resources.roomId)
                if (person) {
                    uName = person.text

                }
                this.showOff(uName, $event.start);
            }
        }

      //  var ii = this.events.findIndex(ff => ff.id == $event.dataItem.id)
      //  if (ii >= 0) {
      //      this.events[ii].start = $event.start;
      //      this.events[ii].end = $event.end;
      //      this.events[ii].isAllDay = false;
      ////      this.createEvents(this.selectedDate);
      //  }
      //  var i = this.data.findIndex(ff => ff.dispatchAssignmentId == $event.dataItem.id)
      //  if (i >= 0) {
      //      this.data[i].startDate = $event.start;
      //      this.data[i].endDate = $event.end;
      //      this.createEvents(this.selectedDate);
      //  }
    }
    createEvents(dayToCalc: Date) {

        if (this.scheduler.selectedView.name == 'day') {

            //startDate

            if (this.svc_data.getShowfutureDispatchs()) {

                this.events = this.data.filter(dd => dd.dispatch ).map(dataItem => (
                    <SchedulerEvent>{
                        id: dataItem.dispatchAssignmentId,
                        start: this.makeItAllDay(dayToCalc, new Date(dataItem.startDate)),
                        startTimezone: dataItem.startTimezone,
                        end: this.makeItAllDay(dayToCalc, new Date(dataItem.startDate)),
                        endTimezone: null,
                        isAllDay: !this.isSameDate(dayToCalc, new Date(dataItem.startDate)),
                        title: ((dataItem.dispatch && dataItem.dispatch.locationName) ? dataItem.dispatch.locationName : ""),
                        visits: ((dataItem.dispatch && dataItem.dispatch.visitCount) ? dataItem.dispatch.visitCount : ""),
                        description: dataItem.dispatchReason,
                        recurrenceRule: null,
                        recurrenceId: null,
                        recurrenceException: null,
                        roomId: dataItem.assignedPersonId,
                        attendees: [dataItem.assignedPersonId],
                        dataItem: dataItem,
                    }

                ));

            }
            else {
                var maxDate = DateFunctions.addDays(dayToCalc, 1);

                this.events = this.data.filter(dd => dd.dispatch && new Date(dd.startDate) < maxDate).map(dataItem => (
                    <SchedulerEvent>{
                        id: dataItem.dispatchAssignmentId,
                        start: this.makeItAllDay(dayToCalc, new Date(dataItem.startDate)),
                        startTimezone: dataItem.startTimezone,
                        end: this.makeItAllDay(dayToCalc, new Date(dataItem.startDate)),
                        endTimezone: null,
                        isAllDay: !this.isSameDate(dayToCalc, new Date(dataItem.startDate)),
                        title: ((dataItem.dispatch && dataItem.dispatch.locationName) ? dataItem.dispatch.locationName : ""),
                        visits: ((dataItem.dispatch && dataItem.dispatch.visitCount) ? dataItem.dispatch.visitCount : ""),
                        description: dataItem.dispatchReason,
                        recurrenceRule: null,
                        recurrenceId: null,
                        recurrenceException: null,
                        roomId: dataItem.assignedPersonId,
                        attendees: [dataItem.assignedPersonId],
                        dataItem: dataItem,
                    }

                ));

            }

        } else {

            this.events = this.data.filter(dd => dd.dispatch).map(dataItem => (
                <SchedulerEvent>{
                    id: dataItem.dispatchAssignmentId,
                    start:  new Date(dataItem.startDate),
                    startTimezone: dataItem.startTimezone,
                    end: new Date(dataItem.startDate),
                    endTimezone: null,
                    isAllDay: false,
                    title: ((dataItem.dispatch && dataItem.dispatch.locationName) ? dataItem.dispatch.locationName : ""),
                    visits: ((dataItem.dispatch && dataItem.dispatch.visitCount) ? dataItem.dispatch.visitCount : ""),
                    description: dataItem.dispatchReason,
                    recurrenceRule: null,
                    recurrenceId: null,
                    recurrenceException: null,
                    roomId: dataItem.assignedPersonId,
                    attendees: [dataItem.assignedPersonId],
                    dataItem: dataItem,
                }

            ));

        }

    }

    isAvailable(curDate: Date, personId: string) {
        var rValue = true;
        if (CommonFunctions.hasArrayValue(this.boardPersonsData))
            {
            var person = this.boardPersonsData.find(a => a.personId == personId)
            var curDateStr = curDate.toDateString(); //toISOString().substring(0,10);
            if (person) {
                var dayOff = person.daysOff.find(a => a == curDateStr)
                if (dayOff) {
                    return false;
                }
            }

            }

        return rValue;

    }

    initData() {
        if (this.selectedView) {
            //this.loadingIndicator = true;
            //this.boardPersonsData = null;
            //this.data = null;

            //getDispatchsByBoardView
            this.svc_data.GetDispatchBoardViewPersons(this.selectedView).subscribe(data => {
                this.boardPersonsData = data;
                if (this.boardPersonsData) {
                    for (var i = 0; i < this.boardPersonsData.length; i++) {
                        for (var ii = 0; ii < this.boardPersonsData[i].daysOff.length; ii++) {
                            this.boardPersonsData[i].daysOff[ii] = (new Date(this.boardPersonsData[i].daysOff[ii])).toDateString();
                        }
                    }

                }
                this.svc_data.boardPersonsData = this.boardPersonsData;

                if (data.error) {
                    alert('got an error back!');
                }

                this.searchParam.boardPersons = [];
                for (var i = 0; i < this.boardPersonsData.length; i++) {
                    this.searchParam.boardPersons.push(this.boardPersonsData[i].personId);
                }

                //this.svc_data_emp.getTechsByFilter(this.searchParam).subscribe(data => {
                //    for (var i = 0; i < data.length; i++) {
                //        data[i].fullName = data[i].firstName + ' ' + data[i].lastName;
                //    }
                //    this.data = data;
                //    this.svc_data.techList = data;
                //    this.loadingIndicator = false;

                //    if (data.error) {
                //        alert('got an error back!');
                //    }
                //
                //});
            });
            this.svc_data_emp.getTechsByFilter(this.svc_data.searchParams).subscribe(data => {
                this.techList = [];
                for (var i = 0; i < data.length; i++) {
                    data[i].fullName = data[i].firstName + ' ' + data[i].lastName;
                    var colorCode = 'transparent';
                    //color: '#6eb3fa'
                    this.techList.push({ text: data[i].fullName, value: data[i].personId, color: colorCode })

                }
                this.resourceCount = this.techList.length;
                this.resources = [{
                    name: 'Techs',
                    data: this.techList,
                    field: 'roomId',
                    valueField: 'value',
                    textField: 'text',
                    colorField: 'color'
                }];
                this.data = data;
                this.svc_data.techList = data;
                this.loadingIndicator = false;
                this.calcWidth();
                if (data.error) {
                    alert('got an error back!');
                }
            });
            this.svc_data.getDispatchsByBoardView(this.selectedView).subscribe(data => {
                this.data = data;
                this.createEvents(this.selectedDate);
                //this.events = data.map(dataItem => (
                //    <SchedulerEvent>{
                //        id: dataItem.TaskID,
                //        start: this.makeItAllDay(this.selectedDate, new Date(dataItem.startDate)),
                //        startTimezone: dataItem.startTimezone,
                //        end: new Date(dataItem.startDate),
                //        endTimezone: null,
                //        isAllDay: this.isSameDate(this.selectedDate, new Date(dataItem.startDate)),
                //        title: dataItem.dispatch.locationName,
                //        description: dataItem.dispatchReason,
                //        recurrenceRule: null,
                //        recurrenceId: null,
                //        recurrenceException: null,
                //        roomId: dataItem.assignedPersonId,
                //        attendees: [dataItem.assignedPersonId],
                //        dataItem: dataItem,

                //    }
                //))
            })
        }
    }
    get singleDay(): boolean {
        var rValue = true;
        if (this.scheduler && this.scheduler.selectedView && this.scheduler.selectedView.name && this.scheduler.selectedView.name != 'day') { return false;}
        return rValue;
        // return this.customFormValidation() && this.serviceMode !== "1" && ((this.saveMode == SaveMode.individual || !this.readOnly) && (this.canSave || this.hasId));
    }
    isSameDate(date1: Date, date2: Date) {
        return date1.getDate() == date2.getDate() &&
            date1.getMonth() == date2.getMonth() &&
            date1.getFullYear() == date2.getFullYear()

    }
    makeItAllDay(date1: Date, date2: Date) {

        if (date1.getDate() == date2.getDate() &&
            date1.getMonth() == date2.getMonth() &&
            date1.getFullYear() == date2.getFullYear()) {return date2 }
        else { return date1}
    }
    menuItems: Array<any> = [{
        text: 'Change Status',
        icon: 'exchange',
        value: 1
    }, {
        text: 'Assign',
        icon: 'user-plus',
        value: 2
    }, {
        text: 'View Dispatch',
        icon: 'th',
        value: 3
    }, {
        text: 'Un-Assign',
        icon: 'user-plus',
        value: 4
    }
    ];

    onMenuItemClick(e, dispatchAssign) {
        console.log(e, dispatchAssign);
        switch (e.value) {
            case 1: //Change Status
                this.moveDispatch.emit(dispatchAssign.dispatch);
                break;
            case 2://Assign
                this.assignDispatch.emit(dispatchAssign.dispatch);
                break;
            case 3: //View Dispatch
                this.viewDispatch.emit(dispatchAssign.dispatch);
                break;
            case 4: //Un-Assign
                this.unAssignDispatch.emit(dispatchAssign);
                break;
        }
    }
    setPriorityClass(priority) {
        let className = '';
        switch (priority) {
            case 'Overtime Approved':
                className = 'priority-overtime-approval';
                break;
            case 'High':
                className = 'priority-high';
                break;
            case 'HOT PARTS - ASAP':
                className = 'priority-hot-parts';
                break;
            case 'Normal':
                className = 'priority-normal';
                break;
            case 'Warranty (Hot)':
                className = 'priority-warranty';
                break;
            case 'PM':
                className = 'priority-pm';
                break;
            case 'LOCKED - SCHEDULED':
                className = 'priority-locked-scheduled';
                break;
            default:
                className = 'priority-nopriority';
        }
        return className;
    }
    public getSlotClass = (args: SlotClassArgs) => {
        const hour = args.start.getHours();

        return {
            evening: !args.isAllDay && (hour < 6 || hour > 19)
        };
    }
    public getSlotClassCustom(arg1: any, arg2: any) {
        var personid = ""
        if (arg2[0] && arg2[0].value) { personid = arg2[0].value;}
        var offFlag = !this.isAvailable(arg1, personid);
        return {
            dayoff: offFlag
        };
    }
    public getIsOff(arg1: any, arg2: any) {
        if (arg2 && arg2[0]) {
            return !this.isAvailable(arg1, arg2[0].value);
        }
        return false;
    }
    logo: any;
    locationDetails: v_LocationDetailBus;
    @ViewChild(TooltipDirective)
    public tooltipDir: TooltipDirective;
    selectedDispatch: string;
    dispatch: any;
    public showTooltip(eventTarget?: any, event?: any): void {
        if (event && event.dataItem && event.dataItem.dataItem.dispatch) {
            this.panelDispatch.emit(event.dataItem.dataItem.dispatch)
        }
    }
    openWindow(dispatch) {
        let passedData = { data: this.data, assignDispatch: dispatch };
        let windowData = { contentType: this.contentTypes.assignTech, boardData: passedData };
        this.openRequest.emit(windowData);
    }

    openDetail(details) {

        this.openDetailRequest.emit({ lock: !this.popupLock, detail: details });
    }

    setPopupLock(e) {
        this.popupLock = e;
    }

    filterChange(e) {
        //is value in list?
        if (e.length > 0 && this.data.find(obj => obj.fullName == e)) {
            this.quickFilterError = false;
            this.resources = [{
                name: 'Techs',
                data: this.techList.filter(item => item.text.indexOf(e) !== -1),
                field: 'roomId',
                valueField: 'value',
                textField: 'text',
                colorField: 'color'
            }];
        } else if (e.length > 0) {
            this.quickFilterError = true;
        } else {
            this.quickFilterError = false;
            this.resources = [{
                name: 'Techs',
                data: this.techList,
                field: 'roomId',
                valueField: 'value',
                textField: 'text',
                colorField: 'color'
            }];
        }
        this.quickFilter = e;
    }

    mouseUp(tech: DispatchDropLocation) {
        if (!this.mouseDown) {
            this.svc_data.dispatchDropped(tech);
        }
        this.mouseDown = false;
    }
    mouseUpSchedular($event) {
        this.slot = this.scheduler.slotByPosition($event.pageX, $event.pageY);
        if (this.slot && !this.slot.isAllDay) {
            if (this.svc_data.dragState.value) {
                if (this.isAvailable(this.slot.start, this.slot.resources[0].value)) {
                   var tech = new DispatchDropLocation();
                   tech.tech = this.slot.resources[0].value;
                   tech.dateTime = this.slot.start;
                   tech.dropTarget = 6;
                   this.svc_data.dispatchDropped(tech);
                   this.mouseDown = false;
               }
               else {
                    this.showOff(this.slot.resources[0].text, this.slot.start);
               }
            }
        }
    }

    mouseOver(tech: DispatchDropLocation) {
        this.svc_data.mouseHovering(tech);
    }

    subs_mouseEnter: Subscription;
    mouseEnter(e, tech) {
        CommonFunctions.unsubscribe(this.subs_mouseEnter);
        this.subs_mouseEnter = this._mouseEnterStream.pipe(mergeMap((ev) => {
            return of(ev)
                .pipe(delay(850))
                .pipe(takeUntil(this._mouseLeaveStream));
        })).subscribe(
            (ev) => {
                tech.isAdded = true;
                this.svc_data.hoveringTechPanel(tech);
            }
        );
    }
    onMouseEnter(e) {

        this._mouseEnterStream.emit(e);
    }

    onMouseLeave(e) {

        this._mouseLeaveStream.emit(e);
    }

    onMouseLeaveDiv(e) {

        this._mouseLeaveStream.emit(e);
    }

    switchView(type: string){
        //this.boardStyle = view;
        if (type == 'grid') {
            this.viewChange.emit(true);
        } else if (type == 'day') {
            this.scheduler.selectedViewIndex = 0;
            this.weekViewWrap = false;
            this.viewChange.emit(false);
        }   else if (type == 'week') {
            this.scheduler.selectedViewIndex = 1;
            this.weekViewWrap = true;
            this.viewChange.emit(false);
        }
    }
    calcWidth(){
        if (this.resourceCount > 3) {
            let width = (this.resourceCount * 182) + 100;
            this.scheduleWidth = width + 'px';
        } else this.scheduleWidth = '100%';
    }
    showOff(message: string = null,ddate:Date) {
        let not: string = message + " has scheduled time off on " + ddate.getMonth().toString() + "/" + ddate.getDate().toString() ;
        this.globals.notifyError(not, true);

    }
    calcLumen(colorValue, visits) {
        if (colorValue && visits && visits > 0) {
            let color = '';
            let r = parseInt(colorValue.substr(1,2),16);
            let g = parseInt(colorValue.substr(3,2),16);
            let b = parseInt(colorValue.substr(5,2),16);
            let yiq = ((r*299)+(g*587)+(b*114))/1000;
            if (yiq >= 128){
                color = '';
            } else {
                color = 'white';
            }

            return color;
        }
    }
}
